import {
  MULTIPLIER_MIN_VALUE,
  MULTIPLE_COUPON_COUNT_MIN_VALUE,
} from 'Store/constants';
import EnvironmentManager from 'Utils/environmentManager';
import { getDefaultStakeLimits } from 'Utils/getDefaultStakeAmount';


const inputMinMaxValidator = limitOption => {
  const MULTIPLIER_MAX_VALUE = EnvironmentManager.getMessageText({ key: 'TM_MAX_STAKE' });
  const multibleCountEnv = EnvironmentManager.getMessageText({ key: 'max_multi_coupon' });
  const multibleCountLiveEnv = EnvironmentManager.getMessageText({ key: 'max_multi_coupon_live' });
  let { system, betCount, id, value, isLive } = limitOption;
  const isCombineCoupon = system.length === 1 && system.includes(betCount);

  let maxValue = 1000;
  let minValue = id === 'multiplier' ? MULTIPLIER_MIN_VALUE : MULTIPLE_COUPON_COUNT_MIN_VALUE;

  if (id === 'multiplier') {
    maxValue = MULTIPLIER_MAX_VALUE;
  } else {
    maxValue = isLive ? multibleCountLiveEnv : multibleCountEnv;
  }

  if (id === 'multiplier') {
    minValue = isCombineCoupon ? getDefaultStakeLimits().min : minValue;
  }

  if (maxValue && +value > maxValue) value = maxValue;
  if (minValue && +value < minValue) value = minValue;
  return { id, value };
};

export default inputMinMaxValidator;
